@use 'config' as config;

:host {
  display: block;

  .canvas {
    position: relative;
    outline: 0;
    cursor: grab;

    &[data-dragging] {
      cursor: grabbing;
    }
  }

  .stage {
    display: flex;
    position: relative;
    width: 100%;
    overflow: scroll;
    scroll-snap-type: none;
    overscroll-behavior-x: none;
    gap: var(--cwc-slider-stage-gap, 0);

    /* hide scrollbar */
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    &[data-snap] {
      scroll-snap-type: x mandatory;
      scroll-snap-stop: always;
    }

    &[data-moving] {
      pointer-events: none;
    }

    ::slotted(*) {
      display: block;
      flex-shrink: 0;
      width: var(--cwc-slider-item-width, 100%);
      scroll-snap-align: start;
    }
  }

  .navigation-arrows {
    display: none;
    pointer-events: none;

    &[data-visible] {
      display: block;
    }

    .button-prev {
      visibility: hidden;
      position: absolute;
      top: 50%;
      left: min(2rem, 3vw);
      transform: translateY(-50%);
    }

    .button-next {
      visibility: hidden;
      position: absolute;
      top: 50%;
      right: min(2rem, 3vw);
      transform: translateY(-50%);
    }

    .button-prev[data-enabled],
    .button-next[data-enabled] {
      visibility: visible;
      z-index: 1;
      pointer-events: auto;
    }
  }

  .navigation-bullets {
    display: flex;
    justify-content: center;
    margin-top: config.$navigation-bullets-mobile-margin-top;

    @media only screen and (min-width: 640px) {
      margin-top: config.$navigation-bullets-margin-top;
    }

    .bullet-container {
      padding: config.$navigation-bullets-bullet-container-padding;
      cursor: pointer;
    }

    @media only screen and (min-width: 640px) {
      &.hide-desktop {
        display: none;
      }
    }

    .bullet {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: config.$bullets-color;

      @media only screen and (min-width: 640px) {
        width: 10px;
        height: 10px;
      }

      &.active {
        background-color: config.$bullets-color-active;
      }
    }
  }
}
